

import { isSocialBro } from '@/lib/broCode/broCodeTypes';

interface CompletionHeaderProps {
  completionRank: string;
}

const CompletionHeader = ({ completionRank }: CompletionHeaderProps) => {
  const getRankSpecificMessage = () => {
    if (isSocialBro(completionRank)) {
      return "Social Brotherhood Achieved!";
    }
    return "Brotherhood Achieved!";
  };

  const getRankDescription = () => {
    if (isSocialBro(completionRank)) {
      return "You've earned your place through social engagement!";
    }
    return `You are now an ${completionRank}`;
  };

  return (
    <div className="text-center">
      <div className="mb-8 flex justify-center">
        <div className="inline-block bg-secondary rounded-full p-4 shadow-lg">
          <img 
            src="/lovable-uploads/clr_4.png" 
            alt="Bromentum Logo" 
            className="w-12 h-12 object-contain"
          />
        </div>
      </div>
      <h2 className="text-4xl font-patrick mb-4 text-tan">{getRankSpecificMessage()}</h2>
      <p className="text-xl text-tan">
        <span className="font-bold text-tan">{completionRank}</span>
      </p>
      <p className="text-lg text-tan-dark mt-2">{getRankDescription()}</p>
    </div>
  );
};

export default CompletionHeader;
